<template>

  <div>

          <language-list v-model="params['locale']"  :isAll="true" @input="params['page'] = 1" />
           <list
              :params="params"
                :columns="columns"
                :modalCreate="modalCreate"
                :removeLink="removeLink"
                :cardLink="cardLink"
                :isUpdate="true"
                :isAdd="true"
                :drag="false"
                :itemLink="itemLink"
                :filters="filters"
                :setLink="setLink"
                :openItem="false"
                :fields="fields"
                :searchDisable="false"
                @change="change"
                @changeFunction="changeFunction"
                v-model="val"
           />

  </div>
</template>
<script>
export default {
  name: "products",
  props:['id'],
  created(){
    this.itemLink = `disciplines/${this.id}/lessonplans`;
    this.setLink = `disciplines/${this.id}/lessonplans`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  
  },
  data() {
    return {
      val: [],
      params: {},
          filters: [
        {
          key: "course",
          single:true,
          title: "Номер Класса",
        },
      ],
      modalCreate: "lessonplan",
      fields: [
          {
          col:'col-12 col-md-4',
          key: "position",
          label: "Номер темы",
          type: "field",
          textType: "number",
        },
         {
           col:'col-12 col-md-8',
          key: "name",
          label: "Название темы",
          type: "field",
          textType: "text",
        },
        {
          col:'col-12 col-md-6',
          key: "locale",
          label: "Локализация контента",
          type: "locale",
          textType: "text",
        },
     
        {
          col: 'col-12 col-md-6',
          label: "Для классов",
          key: "course_id",
          type: "course",

        },
     
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_lessonplan",
      itemLink: "",
      setLink: "",
      columns: [
          {
            key: "position",
            title: "Номер темы",
            checkbox: false,
            inputSet: true,
                    sortBy:'position'
          },
          {
            key: "title",
            title: "Название темы",
            checkbox: false,
          },
          {
            key: "locale",
            title: "Локализация",
            checkbox: false,
          },
          {
            key: "course",
            title: "Класс",
            checkbox: false,
            disableLink: true,
            object:'position'
          },
                 {
          key: "created_at",
          title: "Создан",

           sortBy:'created_at',
             dateTimeFormat: true,
  

        },
          {
              detail: true,
              remove: true,
          },
      ],
    };
  },
};
</script>
<style>
</style>
